import { useEffect, useState } from "react";

export default function ClaimTab({
  tokenSymbol,
  openModal,
  rewardsFormatted,
  claimCountdown,
  claimTime,
  isRootPoolActive,
}) {
  const rewardValue = Number(rewardsFormatted?.replace(/,/g, "")) || 0;
  const [isClaimAvailable, setIsClaimAvailable] = useState(false);

  useEffect(() => {
    if (!claimTime) return;

    const checkTime = () => {
      const currentTime = Math.floor(Date.now() / 1000);
      setIsClaimAvailable(currentTime >= Number(claimTime));
    };

    checkTime();
    const interval = setInterval(checkTime, 1000);
    return () => clearInterval(interval);
  }, [claimTime]);

  // Separate disable logic
  const isClaimDisabled = rewardValue <= 0 || !isClaimAvailable;
  const isRestakeDisabled = rewardValue <= 0 || !isRootPoolActive;

  // console.log("Claim time:", claimTime, "Claim available:", isClaimAvailable);

  return (
    <div className="top_one">
      <div className="inner_top">
        <h3>Claimable Reward</h3>
      </div>

      <div className="input_div lastdro">
        <div className="inter_div newdivvv">
          <div className="inter_text newsection">
            <span className="innnertextt">
              {rewardsFormatted + " " + tokenSymbol}
            </span>
          </div>
        </div>
      </div>

      <div className="top_side_claim">
        <span>Claim available in </span>
        <p className="green_text">{claimCountdown}</p>
      </div>

      <div className="bothbutton">
        <button
          className="restakebutton"
          onClick={() => openModal("restakeFinalize")}
          disabled={isRestakeDisabled}
          style={{
            opacity: isRestakeDisabled ? 0.6 : 1,
            cursor: isRestakeDisabled ? "not-allowed" : "pointer",
          }}
        >
          Restake
        </button>

        <button
          onClick={() => openModal("claimFinalize")}
          disabled={isClaimDisabled}
          style={{
            opacity: isClaimDisabled ? 0.6 : 1,
            cursor: isClaimDisabled ? "not-allowed" : "pointer",
          }}
        >
          Claim Reward
        </button>
      </div>
    </div>
  );
}
